module.exports = __webpack_public_path__ + "static/media/tkm.0500d695.png";